import { Empty } from "antd";
import SelectAllCard from "../selectAll";
import DepositsCard from "../deposits";
import { useTranslation } from "react-i18next";

export default function DepositGrid({
  dataSource = [],
  handleSelectAll,
  handleMultiApproveOrReject,
  selectAllChecked,
  handleMultiDelete,
  handleCheckBoxChange,
  handleApproveOrReject,
  handleDelete,
}) {
  const { t } = useTranslation();
  return (
    <>
      {dataSource.length === 0 ? (
        <Empty
          description={t("common.no_records_found", {
            defaultValue: "No Records Found",
          })}
        />
      ) : (
        <div className="ft-table">
          <table className="table" style={{ cursor: "pointer" }}>
            <thead style={{ backgroundColor: "#F1F1F1" }}>
              <tr>
                <th>
                  <SelectAllCard
                    record={dataSource}
                    handleSelectAll={handleSelectAll}
                    handleMultiApproveOrReject={handleMultiApproveOrReject}
                    selectAllChecked={selectAllChecked}
                    handleMultiDelete={handleMultiDelete}
                  />
                </th>
                <th>
                  {t("common.account_no_lbl", {
                    defaultValue: "Account Number",
                  })}
                </th>
                <th>{t("common.amount", { defaultValue: "Amount" })}</th>
                <th>
                  {t("pages.accounts.deposits.deposit_type", {
                    defaultValue: "Deposit Type",
                  })}
                </th>
                <th>
                  {t("pages.pending_approval.Initiated_Date", {
                    defaultValue: "Initiated Date",
                  })}
                </th>
              </tr>
            </thead>

            <tbody>
              {dataSource.map((option, index) => (
                <DepositsCard
                  record={option}
                  handleCheckBoxChange={handleCheckBoxChange}
                  handleApproveOrReject={handleApproveOrReject}
                  handleDelete={handleDelete}
                />
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
